import axios from "axios";
const baseUrl = "/api";

axios.defaults.withCredentials = true
let accessToken = null;

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

// Update CSRF token header whenever it changes
const updateCsrfToken = () => {
    const csrfToken = getCookie('csrftoken');
    if (csrfToken) {
        axios.defaults.headers.common['X-CSRFToken'] = csrfToken;
    }
};

updateCsrfToken();


//request interceptor to add the auth token header to requests
axios.interceptors.request.use(
  (config) => {
    if (accessToken) {
      config.headers["Authorization"] = "Bearer " + accessToken;
      config.headers["CUUID"] = sessionStorage.getItem("CUUID");

      const csrf = getCookie("csrftoken")
      if (csrf) {
        config.headers["X-CSRFToken"] = csrf;
      }
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

let refreshing = false;

//response interceptor to refresh token on receiving token expired error
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const originalRequest = error.config;

    
    if (error.response.status === 401 && !originalRequest._retry && (originalRequest.url != "/api/token/refresh/" && originalRequest.url != "/api/token/verify/" )) 
    {
      originalRequest._retry = true;

      return axios
        .post(`${baseUrl}/token/refresh/`, {})
        .then((res) => {
          if (res.status === 200) {
            accessToken = res.data.access;
            return axios(originalRequest);
          }
          else {
            window.location.reload();
            return Promise.reject(error);
          }

        });
    }
    else if (error.response.status === 400 && !originalRequest._retry && originalRequest.url == "/api/token/verify/") {
      return axios
        .post(`${baseUrl}/token/refresh/`, {})
        .then((res) => {
          if (res.status === 200) {
            accessToken = res.data.access;
            originalRequest.data = {'token':res.data.access}
            return axios(originalRequest);
          }
          else {
            window.location.reload();
            return Promise.reject(error);
          }

        });
    }
    return Promise.resolve(error);
  }
);


//functions to make api calls
const api = {
  post: (url,body) => {
    return axios.post(`${baseUrl}${url}`, body);
  },

  get: (url, params=null) => {
      return axios.get(`${baseUrl}${url}`, {params:params});
  },

  getBlob :(url, params=null) => {
      return axios.get(`${baseUrl}${url}`, {params:params, responseType: "blob"});
  },

  rawGet: (url, config = {}) => {
    return axios.get(`${baseUrl}${url}`, config);
  },

  put: (url, body) => {
      return axios.put(`${baseUrl}${url}`, body);
  },

  delete: (url, params) => {
      return axios.delete(`${baseUrl}${url}`, {params:params})
  },

  patch: (url, body) => {
      return axios.patch(`${baseUrl}${url}`, body);
  },

  login: async (body) => {
    return await axios.post(`${baseUrl}/token/`, body);
  },
  refreshToken: (body) => {
    return axios.post(`${baseUrl}/token/refresh/`, body);
  },
  verifyToken: () => {
    if (accessToken) {
      return axios.post(`${baseUrl}/token/verify/`, {token:accessToken});
    } else {
      return axios.post(`${baseUrl}/token/refresh/`, {})
    }
  },
  verifyMFACode: async (body) => {
    let res = await axios.post(`${baseUrl}/verify-mfa-code/`, body);
    return res
  },
  logout: (body) => {
    return axios.delete(`${baseUrl}/token/logout/`, body);
  },
  getCsrfToken : () => {
    axios.get(`${baseUrl}/csrf/`);
  },

};
export default api;